import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* globals RadioCanada:true */


import EventEmitter from 'wolfy87-eventemitter';
var loading = false;
var loaded = false;
var events = new EventEmitter();

var loadPlayer = function loadPlayer(opts) {
  return new Promise(function (resolve) {
    if (!loaded && typeof RadioCanada !== 'undefined' && typeof RadioCanada.player !== 'undefined') {
      loaded = true;
    }

    if (loaded) {
      resolve(RadioCanada.player);
      return;
    }

    events.once('loaded', resolve);

    if (loading) {
      return;
    }

    loading = true;

    var options = _objectSpread({
      clientId: 'radiocanadaca_tele',
      url: '//services.radio-canada.ca/media/player/client/{clientId}'
    }, opts);

    var script = document.createElement('script');

    script.onload = function () {
      loaded = true;
      events.emit('loaded', RadioCanada.player);
    };

    script.src = options.url.replace(/\{\s*clientId\s*\}/gi, options.clientId);
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

export default loadPlayer;